import Vue from 'vue'

import { TezosToolkit } from "@taquito/taquito";
import { Tzip12Module } from "@taquito/tzip12";

import { CONTRACTS } from '@hover-labs/kolibri-js'

// const FORCE_MAINNET = true
const FORCE_MAINNET = false

import { createMarkdown } from "safe-marked";
import marked from 'marked'
import {Network} from "@hover-labs/kolibri-js";
import _ from "lodash";

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
    const html = linkRenderer.call(renderer, href, title, text);
    return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};

const markdown = createMarkdown({
    marked: {renderer},
    dompurify: { ADD_ATTR: ['target'] }
});

let NETWORK, NODE_URL, NETWORK_CONTRACTS, TZSTATS_URL, isTestnet, isSandbox
if ((
    // window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ||
    window.location.hostname === 'testnet-governance.kolibri.finance') && !FORCE_MAINNET) {

    NETWORK = Network.Granada
    // NODE_URL = 'https://rpctest.tzbeta.net'
    NODE_URL = 'https://granadanet.api.tez.ie'
    TZSTATS_URL = 'https://granada.tzstats.com'
    NETWORK_CONTRACTS = CONTRACTS.TEST
    isTestnet = true
    isSandbox = false

    // If we're in testnet tell google not to index
    const link = document.createElement('meta');
    link.setAttribute('name', 'robots');
    link.content = 'noindex';
    document.getElementsByTagName('head')[0].appendChild(link);
} else if((window.location.hostname === 'sandbox-governance' ||
           window.location.hostname === 'governance-sandbox.kolibri.finance' ||
           window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost'
    ) && !FORCE_MAINNET) {

    NETWORK = Network.Sandbox
    NODE_URL = 'https://sandbox.hover.engineering'
    TZSTATS_URL = 'https://tzstats.com'
    NETWORK_CONTRACTS = CONTRACTS.SANDBOX
    isTestnet = false
    isSandbox = true
} else {
    NETWORK = Network.Mainnet
    // NODE_URL = 'https://rpc.tzbeta.net'
    NODE_URL = 'https://mainnet.api.tez.ie'
    TZSTATS_URL = 'https://tzstats.com'
    NETWORK_CONTRACTS = CONTRACTS.MAIN
    isTestnet = false
    isSandbox = false
}

const nodeOverrideKey = `${NETWORK}-nodeOverride`
NODE_URL = localStorage.getItem(nodeOverrideKey) ? localStorage.getItem(nodeOverrideKey) : NODE_URL

let state = {
    currentkDAOHoldings: null,
    kDAOCheckpointCount: null,
    kDAOTokenContractStorage: null,
    kdaoToken: null,
    currentBlockHeight: null,
    daoParameters: null,
    proposalDesc: null,
    timelockProposalDesc: null,
    timelockItemOutcome: null,
    wallet: null,
    walletAddress: null,
    isVestingVault: false,
    blockTime: isSandbox ? 4 * 1000 : 15 * 1000,
    nodeURL: NODE_URL,
    network: NETWORK,
    contracts: NETWORK_CONTRACTS,
    tezosToolkit: new TezosToolkit(NODE_URL),
    tzstatsURL: TZSTATS_URL,
    nodeOverrideKey,
    isTestnet,
    isSandbox,
    markdown,
}

state.tezosToolkit.addExtension(new Tzip12Module())

// Update polling interval to 2s in sandbox mode
if (isSandbox){
    state.tezosToolkit.setProvider({config: {confirmationPollingIntervalSecond: 2}})
}

if (NETWORK === Network.Sandbox){
    const sandboxOverrides = localStorage.getItem('sandbox-overrides')
    if (sandboxOverrides !== null){
        const newState = JSON.parse(sandboxOverrides)
        state = _.merge(state, newState)
    }
}

export default Vue.observable(state)
